import axios from 'axios';

// Global error handling for axios
axios.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        window.location.href = `/Account/Login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;
    }
    if (error.response?.status === 500) {
        // In Vue 3, we'll handle this differently through the app instance
        // For now, we'll use a basic alert or console error
        console.error('A critical error has occurred:', error);
        // You can implement a more sophisticated error notification system here
        error.handledGlobally = true;
    }
    return Promise.reject(error);
});

export default axios;